import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

// Login Redux States
import { FORGET_USER } from './actionTypes';
import { forgetUserSuccessful, userForgetPasswordError } from './actions';

// AUTH related methods
import { postForgetPwd, postResetPwd } from '../../../helpers/backendCall';


//If user is login then dispatch redux action's are directly from here.
function* forgetUser({ payload: { user, history } }) {
    if (Object.keys(user).length === 1) {
        try {
            const response = yield call(postForgetPwd, {email: user.username});
            if (response) {
                yield put(
                    forgetUserSuccessful(
                    "Reset link are sended to your mailbox, check there first"
                  )
                );
            }      
        } catch (error) {
            yield put(userForgetPasswordError(error));
        }
    }
    else {
        try {
          const response = yield call(postResetPwd, {email: user.username, code: user.verification, password: user.newPassword});
          if (response) {
              console.log("saga success response 2", response)
              yield put(
                  forgetUserSuccessful(
                  response
                )
              );
          }      
      } catch (error) {
          yield put(userForgetPasswordError(error));
      }
    }
}

export function* watchUserForget() {
    yield takeEvery(FORGET_USER, forgetUser)
}

function* forgetSaga() {
    yield all([fork(watchUserForget)]);
}

export default forgetSaga;